var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span'),_c('v-btn',{staticClass:"delete",on:{"click":_vm.deleteSub}},[_vm._v("Удалить")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }